/**
 * Application constants. Used to avoid magic numbers and document intent.
 * Centralize timing, counts, and configuration here for maintainability.
 */

/** Delay (ms) between stacked panel animations */
export const PANEL_ANIMATION_DELAY_MS = 100;

/** Number of home portfolio images to load immediately (rest lazy-loaded) */
export const LAZY_LOAD_EAGER_COUNT = 6;

/** Number of portfolio items to show per "Show More" batch */
export const PORTFOLIO_BATCH_SIZE = 6;

/** IntersectionObserver rootMargin (px) for lazy loading */
export const LAZY_LOAD_ROOT_MARGIN = '100px';

/** Placeholder count when a portfolio section has no data */
export const PLACEHOLDER_PANEL_COUNT = 6;

/** Theme transition overlay duration (ms); keep under 300ms for responsive feel */
export const THEME_TRANSITION_DURATION_MS = 300;

/** Theme switch delay before applying new theme (ms) */
export const THEME_APPLY_DELAY_MS = 50;

/** Modal fade transition duration (ms) */
export const MODAL_FADE_DURATION_MS = 200;

/** Raw GitHub base for homepage portfolio images (kurtenj-web-images repo) */
export const PORTFOLIO_IMAGES_CDN_BASE =
  'https://raw.githubusercontent.com/kurtenj/kurtenj-web-images/main';

/** Manifest URL for portfolio feed (list of images to show on homepage) */
export const PORTFOLIO_MANIFEST_URL = `${PORTFOLIO_IMAGES_CDN_BASE}/manifest.json`;
